// extracted by mini-css-extract-plugin
module.exports = {"min-width-0":"InputGroup_min-width-0__rzK4U","flex-shrink-0":"InputGroup_flex-shrink-0____gKv"};